export default str => (str || '').split(',').reduce((obj,key)=>{
	obj[key] = true;
	return obj;
},{});